export var QueryHistoryStatus;
(function (QueryHistoryStatus) {
    QueryHistoryStatus["PENDING"] = "pending";
    QueryHistoryStatus["QUEUED"] = "queued";
    QueryHistoryStatus["EXECUTING"] = "executing";
    QueryHistoryStatus["EXPIRED"] = "expired";
    QueryHistoryStatus["READY"] = "ready";
    QueryHistoryStatus["ERROR"] = "error";
    QueryHistoryStatus["CANCELLED"] = "cancelled";
})(QueryHistoryStatus || (QueryHistoryStatus = {}));
//# sourceMappingURL=queryHistory.js.map